import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: true,
  API_PREFIX: 'https://api.scienceglamping.com',
  SOCKET_PREFIX: 'wss://api.scienceglamping.com',
}
